var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterColorfulIcon = function SvgTwitterColorfulIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00AAEC",
    fillRule: "evenodd",
    d: "M20 2.012a7.9 7.9 0 0 1-2.356.676A4.27 4.27 0 0 0 19.448.314a8 8 0 0 1-2.607 1.04A4.01 4.01 0 0 0 13.846 0c-2.264 0-4.101 1.922-4.101 4.291q0 .505.105.978C6.44 5.089 3.417 3.383 1.392.783a4.44 4.44 0 0 0-.555 2.16c0 1.488.724 2.802 1.825 3.572A4 4 0 0 1 .803 5.98v.053c0 2.08 1.415 3.815 3.293 4.208a3.8 3.8 0 0 1-1.081.15 4 4 0 0 1-.773-.076c.523 1.705 2.037 2.946 3.833 2.98A8 8 0 0 1 0 15.072 11.27 11.27 0 0 0 6.29 17c7.548 0 11.674-6.538 11.674-12.21q0-.281-.01-.556A8.5 8.5 0 0 0 20 2.012"
  })));
};
export default SvgTwitterColorfulIcon;